import { useMemo } from "react";
import DailyTaskDetailsRwo, { formatDate } from "./DailyTaskDetailsRwo";
import { MediaItem, TaskListRwo } from "./types/dailyTaskRwo";
import MediaView from "./MediaView";
import { ArrowLeft } from "lucide-react";
import { initials } from "src/utils";

const MEDIA_SECTIONS: { type: MediaItem["type"]; label: string }[] = [
  {
    type: "image",
    label:
      "Morning Meeting or Counselling Photos / Self-activity Geotagged Photos",
  },
  {
    type: "video",
    label:
      "Morning Meeting or Counselling Videos / Self-activity Geotagged Videos",
  },
  { type: "document", label: "Evening Meeting/Counselling Evidences" },
];

const groupByType = (items: MediaItem[]) =>
  MEDIA_SECTIONS.map(({ type, label }) => ({
    type,
    label,
    items: items?.filter((item) => item.type === type),
  })).filter((section) => section.items?.length > 0);

const TaskListDetailsRwo = ({
  task,
  back,
}: {
  task: TaskListRwo;
  back: () => void;
}) => {
  
  const media = task.media;
  const grouped = useMemo(() => groupByType(media), [media]);

  return (
    <div className="my-3">
      <section className="relative overflow-hidden rounded-2xl border border-border bg-gradient-to-br px-2 py-7 from-blue-950/30 via-background to-background flex gap-3 items-center">
        <div className="pointer-events-none absolute -right-12 -top-16 size-48 rounded-full bg-blue-500/[0.06] blur-3xl" />
        <div>
          <button
            className="cursor-pointer p-2 rounded-full hover:bg-gray-200 transition-colors ease-in duration-300"
            onClick={back}
          >
            <ArrowLeft size={20} />
          </button>
        </div>
        <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-[#243F71] text-white shadow-md shadow-blue-950/10 sm:size-14">
              {initials(task.employee_name)}
            </div>
            <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#42679e]">
                  Field Operation
                </span>
                <span className="text-muted-foreground/50">/</span>
                <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
                  Report for {formatDate(task.date)}
                </span>
              </div>
              <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">
                {task.employee_name}
              </h1>
            </div>
          </div>
        </div>
      </section>

      <div className="p-5">
        <MediaView
          media={media}
          grouped={grouped}
          attendanceId={task.attendance_id}
          role="rwo"
        />
      </div>
      {task && <DailyTaskDetailsRwo task={task} />}
    </div>
  );
};

export default TaskListDetailsRwo;
